import { render, staticRenderFns } from "./Subscriptors.vue?vue&type=template&id=148aa94c"
import script from "./Subscriptors.vue?vue&type=script&lang=ts"
export * from "./Subscriptors.vue?vue&type=script&lang=ts"
import style0 from "./Subscriptors.vue?vue&type=style&index=0&id=148aa94c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports